import React, { useEffect, useState } from "react";
import infoIcon from "../../../../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../../helpers/global_helper";
import BetSuccessPopup from "../../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../../Popups/ErrorInnerPopup";
import ConfirmBetDeskonPopup from "../../../../../Popups/ConfirmBetDeskonPopup";
import { formatPricewithdecimal } from "../../../../../NumberFormat";
import { useDispatch, useSelector } from "react-redux";
import CancelledBetDeskonPopup from "../../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance, setCommonConfig } from "../../../../../../redux/actions";
import GameClosedPopup from "../../../GameClosedPopup";
import MarketClose from "../../../MarketClose";

const FourDThreeDTwoDBetFullVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };
  const [bet, setBet] = useState();
  const [reqDataBet, setReqDataBet] = useState({
    dfp: "fullbet",
    gameType: "4d3d2d",
    fastbet: true,
    gameId: null,
    databet: null,
    isfullbet:1,
  });
  const [reqData, setReqData] = useState({
    isfullbet: 1,
    gameId: null,
    gameType: "4d3d2d",
    dfp: "fullbet",
    action: "process",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: [],
  });
  const [respData, setRespData] = useState([]);
  const [finalRespData, setFinalRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCancelledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [angka, setAngka] = useState([]);

  const handleInputChange = (e) => {
    setTotalCountClick(false)
    setBet(e.target.value.replace(/\s+/g, ''));
  };

  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');
  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = betDiscount.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = betDiscount.showMultipleFullbet;
    } else {
      multiple = betDiscount.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type, betDiscount]);

  useEffect(() => {
    if (bet !== undefined && bet.length >= 4) {
      if (bet.includes("+")) {
        const multibet = bet.split("+");
        multibet.map((bets) => {
          const check = bets.split("#");
          if (
            check[0] !== undefined &&
            check[0].length >= 2 &&
            check[1] !== undefined &&
            check[1].length > 0
          ) {
            setReqDataBet({
              ...reqDataBet,
              gameId: gameId,
              databet: bet,
              multiple:multipleValue,
            });
          }
        });
      } else {
        const check = bet.split("#");
        if (
          check[0] !== undefined &&
          check[0].length >= 2 &&
          check[1] !== undefined &&
          check[1].length > 0
        ) {
          setReqDataBet({
            ...reqDataBet,
            gameId: gameId,
            databet: bet,
            multiple:multipleValue,
          });
        }
      }
    }
  }, [bet]);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const callDataBetApi = () => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    } else {
      if (!reqDataBet.databet) {
        showMessage(props.t("format_input"), "error", "error");
        return;
      }

      let matchValidate = matchValidateVersi(gameType, reqDataBet.databet);
      if (matchValidate) {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      }
      makeAjax(url.TOGEL_API.processDataBet, reqDataBet).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
          if (response.code !== "validation_error") {
            showMessage(props.t(response.code), "error", "error");
            return;
          }
          showMessage("server error No data find", "error", "error");
          return;
        }
        setRespData(response.data);
        setShowConfirmationPopup(true);
        let newAngaka = [];
        response.data.dataangka.forEach((item) => {
          const angaka = [item.nomor, item.taruhan, item.status];
          newAngaka.push(angaka);
        });
        setAngka(newAngaka);
      });
    }
  };

  const handleTotalCount = () => {
    if (!reqDataBet.databet) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }

    let matchValidate = matchValidateVersi(gameType, reqDataBet.databet);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }
    makeAjax(url.TOGEL_API.processDataBet, reqDataBet).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        if (response.code !== "validation_error") {
          showMessage(props.t(response.code), "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setRespData(response.data);
      setTotalCountClick(true);
      let newAngaka = [];
      response.data.dataangka.forEach((item) => {
        const angaka = [item.nomor, item.taruhan, item.status];
        newAngaka.push(angaka);
      });
      setAngka(newAngaka);
    });
  };
  const handleFormSubmit = () => {
    callDataBetApi();
  };

  useEffect(() => {
    setReqData({
      ...reqData,
      gameId: gameId,
      dataangka: angka,
    });
  }, [respData]);

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.process4D3D2D, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        if (response.code !== "validation_error") {
          response.code
            ? showMessage(props.t(response.code), "error", "error")
            : showMessage(props.t("guess_bet_wrong"), "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      dispatch(getUserBalance());
      allDataReset();
      setFinalRespData((prevArray) => [...prevArray, response.data]);
      setSuccessPopup(true);
    });
  };

  const allDataReset = () => {
    setBet("");
    setReqDataBet({
      dfp: "isFullBet",
      gameType: "4d3d2d",
      fastbet: true,
      gameId: null,
      databet: null,
      isfullbet:1
    });
    setReqData({
      isfullbet: 1,
      gameId: null,
      gameType: "4d3d2d",
      dfp: "fullbet",
      action: "process",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: [],
    });
    setRespData([]);
    setSuccessPopup(false);
    setShowConfirmationPopup(false);
    setAngka([]);
    setTotalCountClick(false);
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCancelledPopup(true);
  };

  const handlePopupClose = () => {
    setFinalRespData([]);
    setSuccessPopup(false);
    allDataReset();
  };
  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="versicontainer">
            <textarea
              name="bet"
              value={bet}
              onChange={(e) => handleInputChange(e)}
              rows="20"
              placeholder="123*1234*12#5+11*222*333#1+33*777#2"
            ></textarea>
          </div>
          {/* 1 */}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total Line</span> :{" "}
                  {respData.line ? respData.line : "-"}
                </p>
                <p>
                  <span>Total Purchases</span>:{" "}
                  {respData.tover
                    ? formatPricewithdecimal(respData.tover)
                    : "-"}
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total Discount</span> :{" "}
                  {respData.disc >= 0 ? formatPricewithdecimal(respData.disc) : "-"}{" "}
                  &nbsp;
                </p>
                <p>
                  <span>Total Payment</span> :{" "}
                  {respData.pay ? formatPricewithdecimal(respData.pay) : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img
                  src={infoIcon}
                  alt=""
                  // onMouseOver={toggleTooltip}
                  // onMouseOut={toggleTooltip}
                  onClick={toggleTooltip}
                />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        {" "}
                        123*1234*12#5+11*222*333#1+33*777#2
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {multipleValue}
              </p>
            </div>
          </div>

          {/* button*/}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={handleTotalCount}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={allDataReset}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={handleFormSubmit}>{props.t('submit')}</button>
            </div>
          </div>
        </>
      )}

      {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup
            response={finalRespData}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCancelledPopup(false)} />
      )}
      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }
    </div>
  );
};

export default withTranslation()(FourDThreeDTwoDBetFullVersiWap);
